const nav = document.querySelector('.br-nav');
if (nav) {
  const updateNav = () => nav.classList.toggle('scrolled', window.scrollY > 40);
  updateNav();
  window.addEventListener('scroll', updateNav, { passive: true });
}

document.querySelectorAll('[data-year]').forEach((el) => {
  el.textContent = new Date().getFullYear();
});

// Accordion behaviour: opening one FAQ closes the others in its group.
document.querySelectorAll('.faq-item[name]').forEach((detail) => {
  detail.addEventListener('toggle', () => {
    if (!detail.open) return;
    document.querySelectorAll(`.faq-item[name="${detail.getAttribute('name')}"]`).forEach((other) => {
      if (other !== detail) other.open = false;
    });
  });
});

// Mobile Menu Toggle
function toggleMobileMenu() {
  const menu = document.querySelector('.site-menu');
  const overlay = document.querySelector('.mobile-overlay');
  const body = document.body;
  const hamburger = document.querySelector('.hamburger-icon');
  const closeIcon = document.querySelector('.close-icon');

  if (!menu) return;
  const isOpen = menu.classList.toggle('is-open');
  body.classList.toggle('menu-open');
  if (overlay) overlay.classList.toggle('is-open');

  if (isOpen) {
    if (hamburger) hamburger.style.display = 'none';
    if (closeIcon) closeIcon.style.display = 'block';
  } else {
    if (hamburger) hamburger.style.display = 'block';
    if (closeIcon) closeIcon.style.display = 'none';
  }
}

// Close the mobile menu when a menu link is tapped. Same-page links
// (e.g. "Start A Rink" on the contact page) don't reload, so it would stay open.
document.addEventListener('click', (event) => {
  const link = event.target.closest('.site-menu a');
  if (!link) return;
  const menu = document.querySelector('.site-menu');
  if (menu && menu.classList.contains('is-open')) toggleMobileMenu();
});

// Nav group initialisation — runs immediately since script is at end of <body>
function initNav() {
  // Submenu overview links are rendered by sections/header.liquid.

  // Mobile: submenus are always expanded; parent links navigate directly.
  // No accordion toggle needed.
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNav);
} else {
  initNav();
}
